import type { ThemeOptions } from '@mui/material';

export const shadows: ThemeOptions['shadows'] = [
  'none',
  '0 1px 2px rgba(0,0,0,0.3)',
  '0 1px 3px rgba(0,0,0,0.4)',
  '0 2px 4px rgba(0,0,0,0.4)',
  '0 4px 6px -1px rgba(0,0,0,0.4)',
  '0 4px 8px -1px rgba(0,0,0,0.4)',
  '0 6px 10px -1px rgba(0,0,0,0.4)',
  '0 10px 15px -3px rgba(0,0,0,0.5)',
  '0 10px 20px -3px rgba(0,0,0,0.5)',
  '0 15px 25px -3px rgba(0,0,0,0.5)',
  '0 20px 30px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
  '0 25px 50px -5px rgba(0,0,0,0.5)',
];
